import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {
  SET_DEPT_TREE: (state, data) => {
    state.deptTree = data
  }
}

function buildDeptTree(data, parentId) {
  const result = []
  for (const children of data) {
    const pid = children.pId
    if (pid == parentId) {
   children.selected = true
      result.push(children)
      continue
    }
    for (const parent of data) {
      if (parent.id == pid) {
    parent.children = parent.children ? parent.children : []
    parent.selected = true
        parent.children.push(children)
        continue
      }
    }
 }

  return result
}

export const actions = {
  selectAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/student/findCustomerStatistics`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectProvinceByUser({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/student/selProvinceByUser`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  findAllItemByTypeCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findAllItemByCode` + "?typeCode=" + params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  findAllItemByTypeCodeNum({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dictionary/findAllItemByTypeCode` + "?typeCode=" + params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectSubjectTypeByProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/student/selectServiceConditionList?provinceId=` + params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getDeptData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/system/dept/treeData`)
        .then(response => {
          let result = response
          if (response.length > 0) {
            result = buildDeptTree(response, response[0].pId)
            commit('SET_DEPT_TREE', result)
          }
          resolve(result)
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectDataByDept({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/student/summary`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
